import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#fcfcfc',
    color100: '#f0f3f3',
    color200: '#f0f0f0',
    color300: '#cccccc',
    color400: '#b3b3b3',
    color500: '#999999',
    color600: '#666666',
    color700: '#333333',
    color800: '#222222',
    color900: '#111111'
  },
  default: {
    color50: '#d5e3df',
    color100: '#aac7be',
    color200: '#80ac9e',
    color300: '#55907e',
    color400: '#2b745d',
    color500: '#00583d',
    color600: '#004631',
    color700: '#003525',
    color800: '#002318',
    color900: '#00120c'
  },
  accent: {
    color50: '#fbfaf8',
    color100: '#f6f6f1',
    color200: '#f2f1eb',
    color300: '#eeece4',
    color400: '#e9e8dd',
    color500: '#e5e3d6',
    color600: '#b7b6ab',
    color700: '#898880',
    color800: '#5c5b56',
    color900: '#2e2d2b'
  },
  positive: {
    color50: '#d5e3df',
    color100: '#aac7be',
    color200: '#80ac9e',
    color300: '#55907e',
    color400: '#2b745d',
    color500: '#00583d',
    color600: '#004631',
    color700: '#003525',
    color800: '#002318',
    color900: '#00120c'
  },
  negative: {
    color50: '#fad9de',
    color100: '#f6b2bc',
    color200: '#f18c9b',
    color300: '#ec667a',
    color400: '#e83f58',
    color500: '#e31937',
    color600: '#b6142c',
    color700: '#880f21',
    color800: '#5b0a16',
    color900: '#2d050b'
  },
  special: {
    color50: '#feecda',
    color100: '#fcdab5',
    color200: '#fbc790',
    color300: '#fab46a',
    color400: '#f8a245',
    color500: '#f78f20',
    color600: '#c6721a',
    color700: '#945613',
    color800: '#63390d',
    color900: '#311d06'
  }
};

const variant: ACPVariant = {
  id: 'www.aceelitecard.com',
  productTitle: 'ACE Elite Prepaid Account',
  productType: 'gpr',
  accessDomain: {
    subdomain: 'www',
    domain: 'aceelitecard',
    topLevelDomain: 'com'
  },
  colors,
  legacyAcpTheme: 'ace-elite',
  legacyAcpBrandName: 'ace',
  legacyLegosTheme: 'ace-elite',
  status_bar_background_color: colors.default.color500,
  status_bar_foreground_color: 'light',
  contactInfo: {
    name: 'ACE Elite',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@aceelitecard.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '(877) 223-3341',
    phone: '8772233341',
    phone_international: '737-220-8956',
    balance_check_phone: '8772233341',
    balance_check_phone_formatted: '1-877-223-3341',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      appsFlyerBannerKey: 'd916866c-91ad-478d-af16-f8c28fc0bdbe',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: true,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: true
    },
    misc: {
      distributor: 'ACE',
      layoutComponentOverride: false,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#00583D',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#00583D',
      marketingSiteUrl: 'https://www.AceElitePrepaid.com',
      marketingSiteLinkText: 'AceElitePrepaid.com',
      locationSearchMax: '25',
      iOSAppId: '445121924'
    },
    content: {
      signUpContent: "Don't have a card? Sign up today."
    },
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
